import React, { memo, useMemo } from 'react'

import { useSystemDark } from '@/hooks'
import { useThemeContext } from 'react-provider'
import * as DarkIcon from './darkIcon'
import * as LightIcon from './lightIcon'
import { IconImportMapType, IconNameType } from './types/type'

interface PropsIn {
  name: IconNameType
  className?: string
  onClick?: (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => void
  width?: string
  height?: string
  style?: React.CSSProperties
  theme?: 'dark' | 'light' | undefined
}

const Icon = memo(({ name, className, onClick, width, height, style, theme }: PropsIn) => {
  const { isDarkMode } = useThemeContext()
  const systemTheme = useSystemDark()

  const iconUrl = useMemo(() => {
    const propsTheme = theme === void 0 ? false : theme === 'dark' ? true : false

    const Icons: IconImportMapType = (theme ? propsTheme : isDarkMode === null ? systemTheme : isDarkMode) ? DarkIcon : LightIcon
    return Icons[name] || ''
  }, [isDarkMode, theme, name, systemTheme])

  return (
    <img
      className={className ? className : ''}
      src={iconUrl}
      alt={name}
      onClick={(e) => {
        onClick?.(e)
      }}
      width={width}
      height={height}
      style={style}
    />
  )
})

Icon.displayName = 'Icon'
export default Icon
